import React, { FC } from "react";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";

import { paymentInformation, subscriptions } from "../../config/router/routes";
import { PaymentIssueMessageProps } from "./types";

export const PaymentIssueMessage: FC<PaymentIssueMessageProps> = ({
  isPhSubscription,
  isServiceActive,
}) => {
  // A PH_SUBSCRIPTION (crypto/BTCPay) subscription has no payment details to
  // correct: it went past due because nobody paid the renewal invoice, and the
  // only thing to do is pay one - on the subscription card, not on the payment
  // information page.
  if (isPhSubscription) {
    // `past_due` does NOT stop the service: ph-api serves the subscription
    // through the grace period (is_active: true, VPN still unlocked), so the
    // banner says what the subscription card says - the renewal is overdue and
    // paying it keeps the service - instead of announcing an outage that has
    // not happened. Same vocabulary as `renewalPaymentOverdue` on the card, so
    // the two never contradict each other on the same screen.
    if (isServiceActive) {
      return (
        <div>
          <Trans i18nKey="paymentFailurePhSubscriptionOverdue">
            Your renewal payment is overdue.
            <Link className="ams-payment-banner__link" to={subscriptions.path}>
              Pay now
            </Link>
            to keep your service.
          </Trans>
        </div>
      );
    }

    // The service really has stopped: the grace period ran out (the row is no
    // longer active) or a payment-failure standing outlived the subscription.
    // Whether that renewal can still be paid is the subscription page's answer
    // to give - it is the one holding the server's payability - so the link
    // sends the customer there rather than promising a payment here.
    return (
      <div>
        <Trans i18nKey="paymentFailurePhSubscriptionStopped">
          Your service has stopped because the renewal was not paid.
          <Link className="ams-payment-banner__link" to={subscriptions.path}>
            Review your subscription
          </Link>
          to see your options.
        </Trans>
      </div>
    );
  }

  return (
    <div>
      {/* without this wrapper the whitespaces around the link are disappeared
        and adaptivity is incorrect */}
      <Trans i18nKey="paymentFailure">
        There was an issue with your payment. Please check
        <Link className="ams-payment-banner__link" to={paymentInformation.path}>
          your payment details
        </Link>
        and try again.
      </Trans>
    </div>
  );
};
